<div class="profile-container">
    <div class="top-section">
        <div class="back-icon-container" (click)="goBack()">
            <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
        </div>
        <div>
            <div class="icon-title-container">
                <div class="icon-container">
                    <mat-icon svgIcon="user" class="user-icon"></mat-icon>
                </div>
                <p class="title font-poppins">Profile Details</p>
            </div>
            <p class="sub-title">Keep your account information up to date</p>
        </div>
    </div>

    <div class="middle-section">
        <div class="left-section">
            <div class="image-detail-container">
                @if (userDetails?.user?.profileImage) {
                <div class="image-container">
                    <img src="{{ userDetails?.user?.profileImage }}" class="user-image" alt="profile" />
                    <span class="verified-badge">
                        <mat-icon svgIcon="tick" class="verified-icon"></mat-icon>
                    </span>
                </div>
                } @else {
                <div class="user-container">
                    <span class="user-image-icon">
                        {{ userDetails?.user?.name! | initials: 2 }}
                    </span>

                    <span class="verified-badge">
                        <mat-icon svgIcon="tick" class="verified-icon"></mat-icon>
                    </span>
                </div>
                }
                <div class="detail-container">
                    <p class="name-container">
                        <span class="name font-poppins">{{ userDetails?.user?.name }}</span>
                    </p>
                    <p class="member">FunFigz Member</p>
                    <span class="verified">Verified Account</span>
                </div>
            </div>
        </div>

        <div class="right-section">
            <button
                mat-flat-button
                class="btn-primary-gradient edit-profile-button"
                (click)="clickeditProfileDetails(userDetails?.user?.id!)"
            >
                <mat-icon class="edit-icon">edit</mat-icon>
                <span>Edit Profile</span>
            </button>
        </div>
    </div>

    <div class="profile-details-section">
        <p class="title font-poppins">Account Information</p>

        <div class="section-container">
            <div class="section blue-white-gradient">
                <div class="icon-section blue-icon">
                    <mat-icon svgIcon="user" class="section-icon"></mat-icon>
                </div>
                <div class="text-container">
                    <p class="label font-poppins">Full Name</p>
                    <p class="value" appEllipsis maxWidth="100%">{{ userDetails?.user?.name }}</p>
                </div>
            </div>

            <div class="section pink-white-gradient">
                <div class="icon-section pink-icon">
                    <mat-icon svgIcon="phone" class="section-icon"></mat-icon>
                </div>
                <div class="text-container">
                    <p class="label font-poppins">Mobile Number</p>
                    <p class="value">{{ userDetails?.user?.userMobileNumber }}</p>
                </div>
            </div>

            <div class="section yellow-white-gradient">
                <div class="icon-section yellow-icon">
                    <mat-icon svgIcon="mail" class="section-icon yellow-icon"></mat-icon>
                </div>
                <div class="text-container">
                    <p class="label font-poppins">Email Id</p>
                    <p class="value" appEllipsis maxWidth="100%">{{ userDetails?.user?.email }}</p>
                </div>
            </div>

            <div class="section blue-white-gradient">
                <div class="icon-section blue-icon">
                    <mat-icon svgIcon="cake" class="section-icon"></mat-icon>
                </div>
                <div class="text-container">
                    <p class="label font-poppins">age</p>
                    <p class="value">{{ userDetails?.user?.age }} Years</p>
                </div>
            </div>
        </div>
    </div>

    <div class="action-section-container">
        <p class="title font-poppins">Quick Actions</p>
        <div class="section-container">
            <a
                class="section blue-gradient"
                routerLink="/products"
                [queryParams]="{ category: productQueryCategory.BestSeller }"
            >
                <div class="icon-container blue-icon">
                    <mat-icon svgIcon="fullstar" class="section-icon"></mat-icon>
                </div>
                <p class="section-text">Popular Toys</p>
                <p class="subtitle">Discover trending toys for kids</p>
            </a>

            <a class="section pink-gradient" routerLink="/products" [queryParams]="{ sort: 'highOffer' }">
                <div class="icon-container pink-icon">
                    <mat-icon svgIcon="giftbox" class="section-icon"></mat-icon>
                </div>
                <p class="section-text">Special Offers</p>
                <p class="subtitle">Check out amazing deals</p>
            </a>

            <a class="section yellow-gradient" routerLink="/wishlist">
                <div class="icon-container yellow-icon">
                    <mat-icon svgIcon="wishlist" class="section-icon"></mat-icon>
                </div>
                <p class="section-text">Wishlist</p>
                <p class="subtitle">Save toys for later</p>
            </a>
        </div>
    </div>
</div>
